import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import { Button, Navbar, Spinner } from "react-bootstrap";
import { MdLogout } from "react-icons/md";
import "./Header.css";
import API_DOMAIN from "../config/config";

const Header = () => {
  const [isLoading, setIsLoading] = useState(false);
  const initialCompanyId = localStorage.getItem("companyId") || "";

  const [formData, setFormData] = useState({
    company_id: initialCompanyId,
  });
  const [userData, setUserData] = useState([]);

  const fetchData = async () => {
    try {
      const response = await fetch(`${API_DOMAIN}/company.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          search_text: "",
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const responseData = await response.json();
    

      if (responseData.status === 200) {
        setUserData(responseData.data);

      } else {
        throw new Error(responseData.msg);
      }
    } catch (error) {
    }
  };

  useEffect(() => {
    fetchData();
    // Ensure sidebar is open by default on web view (screen width > 768px)
    if (window.innerWidth > 768) {
      document.body.classList.remove("toggle-sidebar");
    }
  }, []);

  const handleToggle = () => {
    document.body.classList.toggle("toggle-sidebar");
  };

  const handleLogout = () => {
    localStorage.removeItem("session");
    window.location.replace("/login");
  };

  const handleCompanyChange = (updatedFormData) => {
    setFormData({ ...formData, company_id: updatedFormData.company_id });
    localStorage.setItem("companyId", updatedFormData.company_id);
    window.location.reload();
  };

  return (
    <div>
      <Navbar className="navfix navbg header fixed-top">
        <Container fluid>
          <div lg={3} xs={3} className="align-self-center">
            <Button
              className="menu-toggle"
              id="menu-toggle"
              onClick={handleToggle}
            >
              <span className="navbar-toggler-icon"></span>
            </Button>
          </div>
          <div lg={3} xs={3} className="user-logo mx-3">
            <img
              src={require("../assests/images/logo2.png")}
              className="img-fluid logo"
              alt=""
            />
          </div>
          <div lg={3} xs={3} className="ms-auto d-flex align-items-center">
            {/* <div className="mx-5 switch-company d-none d-lg-block">
              <DropDownUI
                className="drop-down"
                optionlist={userData.map((user) => ({
                  value: user.company_id,
                  label: user.company_name,
                }))}
                placeholder="Select"
                name="company_id"
                value={formData.company_id}
                onChange={handleCompanyChange}
              />
            </div> */}
            <div lg={3} xs={3} className="ms-auto user-id">
              <Button>
                <MdLogout onClick={handleLogout} />
              </Button>
            </div>
          </div>
        </Container>
      </Navbar>
      {isLoading && (
        <div className="loading-overlay">
          <Spinner animation="border" variant="primary" />
        </div>
      )}
    </div>
  );
};

export { Header };

